import __request__ from "routing/request";
export function getChildrenStateForRoot(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/mitre", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSystemState(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/mitre/threat_coverage_system_state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getChildrenState(node_id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/mitre/${node_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
